import { createSlice } from "@reduxjs/toolkit";

const defaultState = {
    user: null,
    isLogin: false,
    isLoading: true,
    error: null,
    isError: false
}
const AuthSlice = createSlice({
    name: 'auth',
    initialState : defaultState,
    reducers: {
        setLogin(state, action) {
            state.user = action.payload;
            state.isLogin = true;
            state.isLoading = false;
            state.error = null;
            state.isError = false;
        },
        setLogout(state) {
            state.user = null;
            state.isLogin = false;
            state.isLoading = false;
            state.error = null;
            state.isError = false;
        },
        setLoading(state) {
            state.isLoading = true;
            state.error = null;
            state.isError = false;
        },
        setError(state, action) {
            state.isLoading = false;
            state.error = action.error;
            state.isError = true;
        }
    }
});

export const { setLogin, setLogout, setLoading, setError } = AuthSlice.actions;
export default AuthSlice.reducer;